import { useBasicData } from "@/hooks";

import { PoseCreator } from "./components/PoseCreator/PoseCreator";
import { PosePicker } from "./components/PosePicker/PosePicker";

export const Poser = () => {
  const { workspace } = useBasicData();
  if (!workspace) return null;
  const { id: workspaceId, name: workspaceName } = workspace;

  return (
    <>
      <PosePicker workspaceName={workspaceName} workspaceId={workspaceId} />
      <PoseCreator workspaceId={workspaceId} />
    </>
  );
};
